import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig } from "../../../../redux/actions";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import ConfirmDataBetDeskonPopup from "../../../Popups/ConfirmDataBetDeskonPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance } from "../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  respStatus,
  url,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../helpers/global_helper";
import BetFiftyFiftySuccessPopup from "../../../Popups/BetFiftyFiftySuccessPopup";
import { withTranslation } from "react-i18next";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";
import CommonBetHeader from "../CommonBetHeader";

const FiftyFifty2D = (props) => {
  const dispatch = useDispatch();
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const [beli, setBeli] = useState({});
  const [betValue, setBetValue] = useState({});
  const [betPopupValue, setBetPopupValue] = useState({});
  const [angka, setAngka] = useState([]);
  const [respData, setRespData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showConfirmationDataPopup, setShowConfirmationDataPopup] =
    useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [autoBetValue, setAutoBetValue] = useState('');
  const [totalBetAmount, setTotalBetAmount] = useState(0);

  // Store refs for each input
  const inputRefs = useRef([]);
  const colRef = useRef({})

  const handleAutoBet = (value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (regex.test(value)) {
      setAutoBetValue(value);
    } else {
    }
  };

  const handleAutoBetBlur = (value) => {
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setAutoBetValue(value);
    }
  };


  const handleInputFocusDesktop = (e, index, columnName) => {
    if (autoBetValue) {
      handleInputChange(e, index, columnName, autoBetValue);
      // Apply auto bet value to the focused input
      // const updatedBeli = { ...beli, [columnName]: autoBetValue };
      // setBeli(updatedBeli);
      // calculateTotalBetAmount(updatedBeli); // Recalculate total bet

    }
    if (inputRefs.current[index]) {
      inputRefs.current[index].focus();
    }
  };

  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "50502d",
    betTogelAuth: "betTogelAuth",
    allowPartner: null,
    action: "process",
    dataangka: [],
  });

  const [rowsToShow, setRowsToShow] = useState([
    {
      tebak: props.t("small"),
      kei: "1%",
    },
    {
      tebak: props.t("big"),
      kei: "1%",
    },
    {
      tebak: props.t("odd"),
      kei: "1%",
    },
    {
      tebak: props.t("even"),
      kei: "1%",
    },
  ]);

  const betValues = {
    Small: "kecil",
    Big: "besar",
    Odd: "ganjil",
    Even: "genap",
    Kecil: "kecil",
    Besar: "besar",
    Ganjil: "ganjil",
    Genap: "genap",
  };

  const [rowsToShowMo, setRowsToShowMo] = useState([{}, {}, {}, {}, {}]);

  const [selectedValues, setSelectedValues] = useState(
    new Array(rowsToShowMo.length).fill("")
  );

  const handleSelectChange = (index, event) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = event.target.value;
    setSelectedValues(newSelectedValues);
  };

  useEffect(() => {
    if (autoBetValue) {
      selectedValues.forEach((value, index) => {
        if (colRef.current[`${index}-buy`] && value) {
          colRef.current[`${index}-buy`].focus();
        }
      });
    }
  }, [selectedValues]);

  const resetSelection = (index) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = "";
    setSelectedValues(newSelectedValues);
  };

  const handleInputFocus = (e, rowIndex, columnName) => {
    if (autoBetValue !== '') {
      const value = autoBetValue;
      handleInputChange(e, rowIndex, columnName, value);
    }
  };

  const handleInputBlur = (e, rowIndex, columnName, focus = '') => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange(e, rowIndex, columnName, focus = '');
  }

  const handleInputChange = (e, rowIndex, columnName, focus = '') => {
    // const { name, value } = e.target;    
    let name = e.target.name;
    let value = '';

    if (focus != '') {
      value = focus;
    } else {
      value = e.target.value;
    }

    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (!regex.test(value)) {
      return;
    }

    if (isNaN(value)) {
      value = "";
      return;
    }

    const intValue = parseInt(value);
    let minValue = null;
    let maxValue = null;
    minValue = betDiscount.showMin / 1000;
    maxValue = betDiscount.showMax / 1000;
    // if (intValue < minValue) {
    //   localStorage.getItem("I18N_LANGUAGE") == "en"
    //     ? setErrorMessage(`Minimal bet ${minValue + "D"} is 1`)
    //     : setErrorMessage(`Minimal taruhan ${minValue + "D"} adalah 1`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
      setShowErrorPopup(true);
      return;
    }

    // Update the individual bet value
    const updatedBeli = { ...beli, [columnName]: value };
    setBeli(updatedBeli);

    // Recalculate the total bet amount
    calculateTotalBetAmount(updatedBeli)

    setBeli({
      ...beli,
      [name]: value,
    });

    if (value) {
      setBetValue({
        ...betValue,
        [columnName]: selectedValues[rowIndex] ? selectedValues[rowIndex] : value,
      });
    }
    else {
      setBetValue({
        ...betValue,
        [name]: '',
      });
    }

  };

  // Calculate total bet amount
  const calculateTotalBetAmount = (updatedBeli) => {
    let total = 0;
    let discountAmount = betDiscount.showDisc || 0; // Fallback to 0 if undefined
    discountAmount = discountAmount / 100; // Convert percentage to decimal

    Object.keys(updatedBeli).forEach((key) => {
      const value = updatedBeli[key];
      if (!isNaN(value)) {
        total += value * betDiscount.showMultiple;
      }
    });

    const discountedTotal = total > 0 ? total * (1 - discountAmount) : 0;

    setTotalBetAmount(discountedTotal); // Set the final amount after discount
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCancelledPopup(true);
  };

  const submitForm = () => {
    let angka = [];
    const betAmount = Object.values(beli).reduce((total, itme) => total + parseInt(itme), 0);

    const totalAmount = betAmount * betDiscount.showMultiple
    if (totalAmount > user_balance.coin) {
      setErrorMessage(props.t("insufficient_balance"));
      setShowErrorPopup(true);
    } else {
      if (Object.keys(betValue).length > 0) {
        let newBet = [];
        Object.entries(betValue).filter((item, key) => {
          if (beli[item[0]] > 0) {
            device == "Desktop"
              ? (newBet = [item[0], beli[item[0]] * betDiscount.showMultiple, "success"])
              : (newBet = [item[1], beli[item[0]] * betDiscount.showMultiple, "success"]);
            angka.push(newBet);
          }
        });
        if (!Array.isArray(angka) || angka.length === 0) {
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }

        setAngka(angka);
        setShowConfirmationPopup(true);
      } else {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
      }
    }
  };

  useEffect(() => {
    setReqData({
      ...reqData,
      dataangka: angka,
    });
  }, [angka]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.process5050Shio, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setBetPopupValue(betValue);
      setRespData((prevArray) => [...prevArray, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
      resetAllData();
    });

  };

  useEffect(() => {
    resetAllData();
  }, [gameId]);

  const resetAllData = () => {
    setTotalBetAmount(0);
    setSelectedValues(new Array(rowsToShowMo.length).fill(""));
    setAngka([]);
    setBeli({});
    setBetValue({});
    setReqData({
      gameId: gameId,
      gameType: "50502d",
      betTogelAuth: "betTogelAuth",
      allowPartner: null,
      dataangka: [],
    });
    setAutoBetValue('')
  };

  const handlePopupClose = () => {
    setRespData([]);
    setSuccessPopup(false);
  };
  return (
    <div className="fiftyfiftytwenty_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {device === "Desktop" ? (
            <>
              <div className="fiftyfiftytwenty_container">
                <div>
                  <CommonBetHeader gameName={"fiftyFifty2D"} totalBetAmount={totalBetAmount} rowsToShow={null} />
                </div>
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>{props.t("no.")}</th>
                      <th>{props.t("guess")}</th>
                      <th>{props.t("kei")} (%)</th>
                      <th>
                        <input
                          type="text"
                          placeholder="Auto Bet"
                          value={autoBetValue}
                          onChange={(e) => handleAutoBet(e.target.value)}
                          onBlur={(e) => handleAutoBetBlur(e.target.value)}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowsToShow.map((item, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td>{props.t(item.tebak)}</td>
                        <td>{item.kei}</td>
                        <td className="inputs">
                          <input
                            type="text"
                            placeholder="Bet"
                            name={betValues[item.tebak]}
                            value={
                              beli[betValues[item.tebak]]
                                ? beli[betValues[item.tebak]]
                                : ""
                            }
                            onChange={(e) =>
                              handleInputChange(e, index, betValues[item.tebak])
                            }
                            onBlur={(e) =>
                              handleInputBlur(e, index, betValues[item.tebak])
                            }
                            onFocus={(e) => handleInputFocusDesktop(e, index, betValues[item.tebak])} // Pass column name as well
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="container">
              <div>
                <CommonBetHeader gameName={"fiftyFifty2D"} totalBetAmount={totalBetAmount} rowsToShow={null} />
              </div>
              <table>
                <thead>
                  <tr>
                    <th>{props.t("no.")}</th>
                    <th>{props.t("guess")}</th>
                    <th>{props.t("kei")} (%)</th>
                    <th>
                      {" "}
                      <input
                        type="text"
                        placeholder="Auto Bet"
                        value={autoBetValue ? autoBetValue : ''}
                        onChange={(e) => handleAutoBet(e.target.value)}
                        onBlur={(e) => handleAutoBetBlur(e.target.value)}
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]**"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToShowMo.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td className="inputs">
                        <select
                          value={selectedValues[index]}
                          onChange={(e) => handleSelectChange(index, e)}
                        >
                          <option value=""></option>
                          <option value="kecil">{props.t("small")}</option>
                          <option value="besar">{props.t("big")}</option>
                          <option value="ganjil">{props.t("odd")}</option>
                          <option value="genap">{props.t("even")}</option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          // value={betDiscount.kei_besar + '%'}
                          value={
                            betDiscount.kei_besar
                              ? betDiscount.kei_besar + "%"
                              : ""
                          }
                          readOnly
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="Bet"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                          name={`${selectedValues[index]}${index}`}
                          value={
                            beli[`${selectedValues[index]}${index}`]
                              ? beli[`${selectedValues[index]}${index}`]
                              : ""
                          }
                          onFocus={(e) =>
                            handleInputFocus(e, index,
                              `${selectedValues[index]}${index}`)
                          }
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              index,
                              `${selectedValues[index]}${index}`
                            )
                          }
                          onBlur={(e) =>
                            handleInputBlur(
                              e,
                              index,
                              `${selectedValues[index]}${index}`
                            )
                          }
                          disabled={selectedValues[index] ? false : true}
                          ref={(el) => (colRef.current[`${index}-buy`] = el)}
                        />
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("50502D_text")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button onClick={resetAllData} className="reset">
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button onClick={submitForm} className="submit">
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
      )}
      {showConfirmationDataPopup && (
        <ConfirmDataBetDeskonPopup
          onClose={() => setShowConfirmationPopup(false)}
          submitProcessOk={submitProcessOk}
        />
      )}
      {successPopup && (
        <div className="popup-overlay ">
          <BetFiftyFiftySuccessPopup
            response={respData}
            betValue={betPopupValue}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }
    </div>
  );
};

export default withTranslation()(FiftyFifty2D);
